export default __webpack_public_path__ + "static/media/01_DAIF_Data_01_loop.a6f65811.mp4";